import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React, { forwardRef } from "react";
import { BaseChip } from "./BaseChip";
export var Chip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "neutral" : _ref$color,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseChip, _extends({}, rest, {
    color: color,
    ref: ref
  }));
});
Chip.displayName = "Chip";
//# sourceMappingURL=Chip.js.map